var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fr-kba-form-group',{ref:"kbaFormGroup",attrs:{"selfServiceDetails":_vm.selfServiceDetails}})}
var staticRenderFns = []

export { render, staticRenderFns }